var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCo2Emissions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#1A48BE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.0005 55.0005C90.0005 53.0114 89.0523 51.1037 87.3645 49.6972C85.6766 48.2907 83.3874 47.5005 81.0005 47.5005H74.3795C73.3617 44.5163 71.1633 41.9065 68.1412 40.0948C65.119 38.2832 61.4507 37.3761 57.7319 37.5209C54.0132 37.6656 50.4623 38.8538 47.6561 40.8924C44.8498 42.931 42.9529 45.7003 42.2735 48.7505M76.5005 82.5005H51.0005C47.1061 82.4997 43.2887 81.5964 39.9748 79.8917C36.661 78.1869 33.9812 75.7479 32.2351 72.847C30.4889 69.9462 29.7452 66.6979 30.0869 63.4651C30.4286 60.2322 31.8423 57.1423 34.17 54.5405C36.4978 51.9387 39.6479 49.9275 43.2683 48.7317C46.8887 47.536 50.8368 47.2027 54.6714 47.7692C58.5061 48.3356 62.0761 49.7795 64.9827 51.9395C67.8892 54.0995 70.0178 56.8905 71.1305 60.0005H76.5005C78.2733 60.0005 80.0288 60.2915 81.6667 60.8569C83.3046 61.4222 84.7928 62.2509 86.0464 63.2956C87.3 64.3402 88.2944 65.5804 88.9729 66.9453C89.6513 68.3102 90.0005 69.7731 90.0005 71.2505C90.0005 72.7279 89.6513 74.1908 88.9729 75.5557C88.2944 76.9206 87.3 78.1608 86.0464 79.2055C84.7928 80.2501 83.3046 81.0788 81.6667 81.6442C80.0288 82.2095 78.2733 82.5005 76.5005 82.5005Z",
    stroke: "#FCFEFF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo2Emissions);
export default __webpack_public_path__ + "static/media/co2-emissions.af7dacc3eeb2645f577a8bd03f192443.svg";
export { ForwardRef as ReactComponent };